/**
 * What the marker is told when the room is unreachable.
 *
 * NO COUNT, deliberately. "3 unsynced" is a number a marker cannot act on and
 * will reasonably read as three lost scores — and the correct behaviour is to
 * carry on throwing, which a figure that looks like damage discourages. The
 * count goes to the admin, on the boards panel, where somebody can do
 * something about it.
 *
 * Two situations, because the right instruction differs:
 *
 *   scoring   play continues and the queue drains later. Keep going.
 *   waiting   the next match cannot be started without the room, so the board
 *             is genuinely stuck and an admin needs to know now.
 */

export default function OfflineBanner({ variant = 'scoring' }) {
  const waiting = variant === 'waiting';

  return (
    <div className={`hd-scorer-banner ${waiting ? 'hd-scorer-banner-stuck' : ''}`} role="status">
      <strong>
        {waiting ? 'Lost Connection – Contact Admin' : 'Lost Connection – Awaiting Resync'}
      </strong>
      <span>
        {waiting
          ? 'This board cannot start the next match until it reconnects. Please let an admin know.'
          : 'Scores are being saved on this tablet. Keep playing, and let an admin know.'}
      </span>
    </div>
  );
}
